import React, { useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

interface HeaderProps {
  onCopyToClipboard?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onCopyToClipboard }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();

    const scrollToElement = (id: string) => {
      const element = document.getElementById(id);
      if (element) {
        const headerHeight = 80;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    };

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scrollToElement(sectionId);
      }, 100);
    } else {
      scrollToElement(sectionId);
    }

    if (isMenuOpen) {
      toggleMenu();
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-content">
          <button
            className={`menu-button ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="logo-container">
            <a href="/" className="logo-link">
              <span className="logo-text">Thermomix Dünyası</span>
            </a>
          </div>

          <nav className="desktop-menu">
            <ul className="menu-list">
              <li>
                <a
                  href="#ozellikler"
                  className="menu-link"
                  onClick={(e) => handleNavClick(e, 'ozellikler')}
                >
                  Thermomix TM7 Nedir?
                </a>
              </li>
              <li>
                <a
                  href="#aksesuarlar"
                  className="menu-link"
                  onClick={(e) => handleNavClick(e, 'aksesuarlar')}
                >
                  Aksesuarlar
                </a>
              </li>
              <li>
                <a
                  href="#bilgi-formu"
                  className="menu-link"
                  onClick={(e) => handleNavClick(e, 'bilgi-formu')}
                >
                  Sipariş Formu
                </a>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <a
              href="#bilgi-formu"
              className="btn btn-primary"
              onClick={(e) => handleNavClick(e, 'bilgi-formu')}
              aria-label="Sipariş formuna git"
            >
              Sipariş Oluştur
            </a>

          </div>
        </div>

        <nav className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-bg" onClick={toggleMenu}></div>
          <div className="mobile-menu-list">
            <div className="mobile-menu-header">
              <div className="mobile-menu-logo">
                <h2 className="mobile-menu-title">Thermomix Dünyası</h2>
                <p className="mobile-menu-subtitle">Thermomix Dünyasına Hoş Geldiniz. TM7 ile Mutfakta Yeni Bir Çağ Başlıyor</p>
              </div>
              <div className="mobile-menu-divider"></div>
            </div>

            <div className="mobile-menu-contact">

              <div className="mobile-menu-contact-buttons">
                <a
                  href="https://wa.me/905369900797?text=Merhaba, Thermomix TM7 hakkında bilgi almak istiyorum."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mobile-menu-contact-btn mobile-menu-whatsapp"
                  onClick={toggleMenu}
                  aria-label="WhatsApp ile iletişime geç"
                >
                  WhatsApp
                </a>
                <a
                  href="tel:05369900797"
                  className="mobile-menu-contact-btn mobile-menu-phone"
                  onClick={toggleMenu}
                  aria-label="Telefon ile ara"
                >
                  Ara
                </a>
              </div>
            </div>

            <div className="mobile-menu-divider"></div>

            <ul className="mobile-menu-links">
              <li>
                <a
                  href="#ozellikler"
                  className="mobile-menu-link"
                  onClick={(e) => handleNavClick(e, 'ozellikler')}
                >
                  Thermomix TM7 Nedir?
                </a>
              </li>
              <li>
                <a
                  href="#aksesuarlar"
                  className="mobile-menu-link"
                  onClick={(e) => handleNavClick(e, 'aksesuarlar')}
                >
                  Aksesuarlar
                </a>
              </li>
              <li>
                <a
                  href="#bilgi-formu"
                  className="mobile-menu-link"
                  onClick={(e) => handleNavClick(e, 'bilgi-formu')}
                >
                  Sipariş Formu
                </a>
              </li>

            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;

